import * as React from 'react'
import XSymbolImg from '../../../assets/images/x-symbol.svg'
import { addNoScroll, removeNoScroll } from '../../../utils/overflowHelper'
import { Terms } from './terms'
import { newFormatTerms } from './new-format-terms'
import './modal-terms.scss'

export const ModalTerms = ({ onClose }) => {
  React.useEffect(() => {
    addNoScroll()

    return () => {
      removeNoScroll()
    }
  }, [])

  const escFunction = event => {
    if (event.key === 'Escape') {
      onClose()
    }
  }

  return (
    <div
      className="f-modal-terms"
      onKeyDown={escFunction}
      role="button"
      tabIndex={0}
    >
      <div className="f-modal-terms__body">
        <button
          aria-label="close modal"
          onClick={onClose}
          className="f-modal-terms__body__close-icon"
        >
          <img src={XSymbolImg} alt="close modal" />
        </button>

        <h2 className="f-modal-terms__body__title">TÉRMINOS Y CONDICIONES</h2>
        {
          process.env.LOCALE !== "es-PE" ?

        <ol className="f-modal-terms__body__description" type="1">
          {
            Terms.map(({text},index) =>{
              return (
                <li key={index} dangerouslySetInnerHTML={{ __html: text}}
                />
              )
            })
          }
        </ol>
        :
        <>
          <div  className='f-modal-terms__body__description'>
            <div className='f-modal-terms__body__description__header'>
              <h3 className='f-modal-terms__body__description__header__title'>
                {newFormatTerms.header.h3Title}
              </h3>
              <p className='f-modal-terms__body__description__header__subtitle'>
                {newFormatTerms.header.pSubtitle}
              </p>
            </div>
            {
              newFormatTerms.content.map(({h4title,description},index) =>{
                return (
                  <div className='f-modal-terms__body__description__content'>
                    <h4 className='f-modal-terms__body__description__content__title' key={index} dangerouslySetInnerHTML={{ __html: h4title}} />
                    <p className='f-modal-terms__body__description__content__text' key={index} dangerouslySetInnerHTML={{ __html: description.text}} />
                    {
                      description.item !== [] &&
                      <ol className='f-modal-terms__body__description__content__text__list' start='1' >
                        {
                          description.item.map((text,index) =>{
                            return (
                              <li className='f-modal-terms__body__description__content__text__list-item' key={index} dangerouslySetInnerHTML={{ __html: text}}
                              />
                            )
                          })
                        }
                      </ol>
                    }
                  </div>
                )
              })
            }
          </div>
        </>
        }
      </div>
    </div>
  )
}
